import React, { useState, useEffect, Fragment } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  ListGroup,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import axios from "axios";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Tabledata from "./Tabledata";
import TabledataCommander from "./TabledataCommander";
import LoadingRound from "../TESTPage/LoadingRound";
import PinCode from "../../components/PinCode/PinCode";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import PinFalse from "../../components/PinCode/PinFalse";
import PinTrue from "../../components/PinCode/PinTrue";
import UserTax from "../TaxAndDeduct/Tax/UserTax";
import UserDeduct from "../TaxAndDeduct/Deduct/UserDeduct";
import ViewSlipmoney from "../Financial/ViewSlipmoney";
import { Tooltip } from "@mui/material";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingPage from "../TESTPage/LoadingPage";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
// import { Breadcrumbs } from "@mui/material";

const API_URL = process.env.REACT_APP_API_CORS;

const Evaluate = () => {
  const [userInfo, setUserInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [PINtrue, setPINtrue] = useState(false);
  const [authenPIN, setAuthenPIN] = useState(null);
  const [authenPINFlase, setAuthenPINFlase] = useState(false);
  const [dataInfo, setDataInfo] = useState(null);
  const [pinCase, setPinCase] = useState(null);
  const token = GetCookieToken("userToken");
  const userData = GetCookieData("userData");
  const userPosition = GetCookieData("userPosition");  
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const paramName = params?.get("menu");
  const navigate = useNavigate();
  const [showTextID1, setShowTextID1] = useState(false);
  const [showTextID2, setShowTextID2] = useState(false);
  const [showTextID3, setShowTextID3] = useState(false);
  const [showTextID4, setShowTextID4] = useState(false);
  const [showTextID5, setShowTextID5] = useState(false);
  const [showTextID6, setShowTextID6] = useState(false);
  const [showTextID7, setShowTextID7] = useState(false);

  document.title = "การประเมินผลการปฎิบัติราชการ | Flexible-Time";

  const handleShowtext = async (task, btnslt) => {

      if (paramName === null) {
        setShowTextID1(true);
        setShowTextID2(false);
        setShowTextID3(false);
        setShowTextID4(false);
        setShowTextID5(false);
        setShowTextID6(false);
        setShowTextID7(false);
      } else {
        setShowTextID1(false);
      }

      if (paramName === "assessmentmyself") {
        setShowTextID2(true);
        setShowTextID1(false);
        setShowTextID3(false);
        setShowTextID4(false);
        setShowTextID5(false);
        setShowTextID6(false);
        setShowTextID7(false);
      } else {
        setShowTextID2(false);
      }

      if (paramName === "subordinate") {
        setShowTextID3(true);
        setShowTextID2(false);
        setShowTextID1(false);
        setShowTextID4(false);
        setShowTextID5(false);
        setShowTextID6(false);
        setShowTextID7(false);
      } else {
        setShowTextID3(false);
      }

      if (paramName === "subordinatemyself") {
        setShowTextID4(true);
        setShowTextID3(false);
        setShowTextID2(false);
        setShowTextID1(false);
        setShowTextID5(false);
        setShowTextID6(false);
        setShowTextID7(false);
      } else {
        setShowTextID4(false);
      }

      if (paramName === "tax_deduct_money_slip") {
        setShowTextID5(true);
        setShowTextID4(false);
        setShowTextID3(false);
        setShowTextID2(false);
        setShowTextID1(false);
        setShowTextID6(false);
        setShowTextID7(false);
      } else {
        setShowTextID5(false);
      }

      if (paramName === "tax_deduction") {
        setShowTextID6(true);
        setShowTextID5(false);
        setShowTextID4(false);
        setShowTextID3(false);
        setShowTextID2(false);
        setShowTextID1(false);
        setShowTextID7(false);
      } else {
        setShowTextID6(false);
      }

      if (paramName === "salary_slip") {
        setShowTextID7(true);
        setShowTextID4(false);
        setShowTextID3(false);
        setShowTextID2(false);
        setShowTextID1(false);
        setShowTextID6(false);
        setShowTextID5(false);
      } else {
        setShowTextID7(false);
      }
  };

  const EvaluateMenu = [
    {
      icon: <i className="fa-solid fa-file px-1"></i>,
      name: (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && 
            ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3))) 
              ? "การประเมินผลการปฎิบัติข้าราชการ" : "การประเมินตนเอง",
      buttonSectionID: 0,
      bottonShowText: showTextID1,
      path: "",
      activeClick:null,
    },
    {
      icon: <i className="fa-solid fa-file-user px-1"></i>,
      name: "การประเมินตนเอง",
      buttonSectionID: 1,
      bottonShowText: showTextID2,
      path: "/?menu=assessmentmyself",
      activeClick:"assessmentmyself",
    },
    {
      icon: <i className="fa-solid fa-money-check-pen px-1"></i>,
      name: (CheckSubAdmin(userInfo?.positionSubAdmin).length > 0) && 
            ((CheckSubAdmin(userInfo?.positionSubAdmin).includes(0) || CheckSubAdmin(userInfo?.positionSubAdmin).includes(3))) 
              ? "การประเมินผู้ใต้บังคับบัญชา" : "การประเมินผู้ใต้บังคับบัญชาของตนเอง",
      buttonSectionID: 2,
      bottonShowText: showTextID3,
      path: "/?menu=subordinate",
      activeClick:"subordinate",
    },
    {
      icon: <i className="fa-solid fa-pen-to-square px-1"></i>,
      name: "การประเมินผู้ใต้บังคับบัญชาของตนเอง",
      buttonSectionID: 3,
      bottonShowText: showTextID4,
      path: "/?menu=subordinatemyself",
      activeClick:"subordinatemyself",
    },
    {
      icon: <i className="fa-solid fa-file-invoice-dollar px-1"></i>,
      name: "ใบเงินเดือน ใบภาษี และ ใบลดหย่อนภาษี",
      buttonSectionID: 4,
      bottonShowText: showTextID5,
      path: "/?menu=tax_deduct_money_slip",
      activeClick:"tax_deduct_money_slip",
    },
    // {
    //   icon: <i className="fa-solid fa-envelope-open-dollar px-1"></i>,
    //   name: "ใบลดหย่อนภาษี",
    //   buttonSectionID: 5,
    //   bottonShowText: showTextID6,
    //   path: "/?menu=tax_deduction",
    //   activeClick:"tax_deduction",
    // },
    // {
    //   icon: <i className="fa-solid fa-money-check-dollar-pen px-1"></i>,
    //   name: "ใบเงินเดือน",
    //   buttonSectionID: 6,
    //   bottonShowText: showTextID7,
    //   path: "/?menu=salary_slip",
    //   activeClick:"salary_slip",
    // },
  ];

  const responsiveLayoutSizes = {
    MD: 12,
    LG: 12,
    XL: 12,
    XXL: 12,
  };

  useEffect(() => {
    handleShowtext()
  }, [paramName]);


  const fetchInfo = async () => {
    const urlInfo = `${API_URL}/api/users/info`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    await axios
      .get(urlInfo, config)
      .then((response) => {
        setUserInfo(response?.data?.result);
        // if (userData?.positionSubAdmin?.length > 0) {
        //   const filterSubAdmin = userData.positionSubAdmin.map(
        //     (i) => i.type_sub_admin
        //   );
        //   if (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 3) {
        //     setAuthenPIN(true);
        //   }else{
        //     if ((response.data.result.pin_code !== null && response.data.result.pin_code !== "")) {
        //       setAuthenPIN(false);
        //       setDataInfo(response.data.result.pin_code);
        //     } else {
        //       setAuthenPIN(true);
        //     }
        //   }
        // }
        // else{
        if ((response.data.result.pin_code !== null && response.data.result.pin_code !== "")) {
          setAuthenPIN(false);
          setDataInfo(response.data.result.pin_code);
        } else {
          setAuthenPIN(true);
        }
        // }
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // useEffect(() => {
  //   fetchInfo();
  // }, []);

  const handleButtonClick = (value) => {
    if ((value === "กำลังโหลดข้อมูล")) {
        setLoading(true);
    }
    if ((value === "โหลดเสร็จสิ้น")) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  };

  useEffect(() => {
    setLoading(true);
    
    setTimeout(() => {
      fetchInfo()
      
    }, 1500);
  }, []);

  const handlePinSubmit = (pin) => {
    setPinCase(pin);
    if (pin === dataInfo) {
      setAuthenPIN(true);
      setPINtrue(true);
      setTimeout(() => {
        setPINtrue(false);
      }, 1500);
    } else {
      setPinCase(pin);
      setAuthenPINFlase(true);
    }
  };

  const PinChange = () => {
    setAuthenPINFlase(false);
  };
// CheckPosition(userData?.position)?.includes(1)

  return (
    <Fragment>
      {authenPIN === false ? (
        <PinCode onSubmit={handlePinSubmit} />
      ) : PINtrue ? (
        <Modal isOpen={PINtrue} centered>
          <ModalBody>
            <PinTrue />
          </ModalBody>
        </Modal>
      ) : loading ? (
        <div className="page-content mb-5">
          <Container fluid>
            <Card>
              <CardBody>
                <LoadingPage />
              </CardBody>
            </Card>
          </Container>
        </div>
      ) : (
        <div className="page-content">
          <Container fluid>
            {/* <div
              className="d-flex justify-content-center m-2"
              style={{
                display: "flex",
                flexWrap: "nowrap",
                overflowX: "auto",
                gap: "10px",
              }}
            > */}
              <Row>
                <Col className="custom-menu">
                  {EvaluateMenu?.map((item, idx) => {
                    return  userPosition?.length > 0 ? 
                      item.buttonSectionID === 2 ||
                      item.buttonSectionID === 0 ? (
                      // <Row className="mb-3 " >
                      //   <Col>
                          <Tooltip title={item?.name}>
                            <button
                              className={
                                paramName === item?.activeClick
                                  ? "rounded-pill btn btn-primary"
                                  : "rounded-pill btn btn-outline-primary"
                              }
                              onClick={() => {
                                // setButtonSection(idx);
                                handleShowtext();
                                navigate(`/assessment${item?.path}`);
                              }}
                            >
                              <Row>
                                <Col className="d-flex justify-content-center">
                                  {item?.icon}
                                  {item.bottonShowText && (
                                  <FadeIn>
                                    <span
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center ps-2"
                                    >
                                      {item?.name}
                                    </span>
                                  </FadeIn>
                                  )}
                                </Col>
                              </Row>
                            </button>
                          </Tooltip>
                      //   </Col>
                      // </Row>
                    ) : (
                      ""
                    ) : item.buttonSectionID === 0 ? (
                      // <Row className="mb-3 " >
                      //   <Col >
                          <Tooltip title={item?.name}>
                            <button
                              className={
                                paramName === item?.activeClick
                                  ? "rounded-pill btn btn-primary"
                                  : "rounded-pill btn btn-outline-primary"
                              }
                              onClick={() => {
                                // setButtonSection(idx);
                                handleShowtext();
                                navigate(`/assessment${item?.path}`);
                              }}
                            >
                              <Row>
                                <Col className="d-flex justify-content-center">
                                  {item?.icon}
                                  {item.bottonShowText && (
                                  <FadeIn>
                                    <span
                                      style={{ whiteSpace: "nowrap" }}
                                      className="text-center ps-2"
                                    >
                                      {item?.name}
                                    </span>
                                  </FadeIn>
                                  )}
                                </Col>
                              </Row>
                            </button>
                          </Tooltip>
                      //   </Col>
                      // </Row>
                    ) : (
                      ""
                    )
                  })}
                  {/* {userData?.positionSubAdmin?.length > 0 ? ( */}
                  {userData?.positionSubAdmin?.length > 0 ? (
                    CheckPosition(userPosition) && CheckPosition(userPosition)?.includes(1) ? (
                        ""
                      ) : (
                        <Fragment>
                          {EvaluateMenu?.map((item, idx) => {
                            return item.buttonSectionID === 1 ||
                              // item.buttonSectionID === 1 ||
                              item.buttonSectionID === 3 ||
                              item.buttonSectionID === 4 ||
                              item.buttonSectionID === 5 ||
                              item.buttonSectionID === 6 ? (
                                  <Tooltip title={item?.name} key={idx + 1}>
                                    <button
                                      className={
                                        paramName === item?.activeClick
                                          ? "rounded-pill btn btn-primary"
                                          : "rounded-pill btn btn-outline-primary"
                                      }
                                      onClick={() => {
                                        // setButtonSection(idx);
                                        handleShowtext();
                                        navigate(`/assessment${item?.path}`);
                                      }}
                                    >
                                      <Row>
                                        <Col className="d-flex justify-content-center">
                                          {item?.icon}
                                          {item.bottonShowText && (
                                          <FadeIn>
                                            <span
                                              style={{ whiteSpace: "nowrap" }}
                                              className="text-center ps-2"
                                            >
                                              {item?.name}
                                            </span>
                                          </FadeIn>
                                          )}
                                        </Col>
                                      </Row>
                                    </button>
                                  </Tooltip>
                            ) : (
                              ""
                            );
                          })}
                        </Fragment>
                      )
                    // )
                  ) 
                  : (
                    <Fragment>
                      {EvaluateMenu?.map((item, idx) => {
                        let screeningCommittee = userInfo?.user_new_id === 9
                        return item.buttonSectionID === 4 ||
                          item.buttonSectionID === 5 ||
                          item.buttonSectionID === 6 || (item.buttonSectionID === 3 && screeningCommittee) ? (
                              <Tooltip title={item?.name}>
                                <button
                                  className={
                                    paramName === item?.activeClick
                                      ? "rounded-pill btn btn-primary"
                                      : "rounded-pill btn btn-outline-primary"
                                  }
                                  onClick={() => {
                                    // setButtonSection(idx);
                                    handleShowtext();
                                    navigate(`/assessment${item?.path}`);
                                  }}
                                >
                                  <Row>
                                    <Col className="d-flex justify-content-center">
                                      {item?.icon}
                                      {item.bottonShowText && (
                                      <FadeIn>
                                        <span
                                          style={{ whiteSpace: "nowrap" }}
                                          className="text-center ps-2"
                                        >
                                          {item?.name}
                                        </span>
                                      </FadeIn>
                                      )}
                                    </Col>
                                  </Row>
                                </button>
                              </Tooltip>
                        ) : (
                          ""
                        );
                      })}
                    </Fragment>
                  )
                  }
                </Col>
              </Row>
            
            {/* </div> */}

            <Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={2}></Col>
            {/* <Breadcrumb
              title="หน้าหลัก"
              breadcrumbItem="การประเมินผลการปฏิบัติราชการ"
              home={true}
            /> */}
            <ListGroup>
              <Row>
                {paramName === "subordinate" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <TabledataCommander userInfo={userInfo}/>
                  </Col>
                )}
                {paramName === "subordinatemyself" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <TabledataCommander userInfo={userInfo} conditon_for_admin={false}/>
                  </Col>
                )}
                {paramName === "assessmentmyself" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <Tabledata handleLoad={handleButtonClick} userInfo={userInfo} conditon_for_admin={false}/>
                  </Col>
                )}
                {paramName === null && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <Tabledata handleLoad={handleButtonClick} userInfo={userInfo}/>
                  </Col>
                )}
                {paramName === "tax_deduct_money_slip" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <UserTax userInfo={userInfo}/>
                  </Col>
                )}
                {/* {paramName === "tax_deduction" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <UserDeduct userInfo={userInfo}/>
                  </Col>
                )}
                {paramName === "salary_slip" && (
                  <Col
                    md={responsiveLayoutSizes.MD}
                    lg={responsiveLayoutSizes.LG}
                    xl={responsiveLayoutSizes.XL}
                    xxl={responsiveLayoutSizes.XXL}
                  >
                    <ViewSlipmoney userInfo={userInfo}/>
                  </Col>
                )} */}
              </Row>
            </ListGroup>
          </Container>
        </div>
      )}
      {/* {authenPINFlase === true ? */}
      <Modal toggle={PinChange} isOpen={authenPINFlase} centered>
        <ModalBody>
          <div className="text-center">
            <PinFalse />
            {pinCase !== dataInfo && pinCase !== "" ? (
              <h5 className="text-danger">รหัสลับ (PIN) ไม่ถูกต้อง</h5>
            ) : (
              <h5 className="text-danger">กรุณา ระบุรหัสลับให้ครบ 4 ตัว</h5>
            )}
            <Button color="primary" onClick={PinChange}>
              ตกลง
            </Button>
          </div>
        </ModalBody>
      </Modal>
      {/*  :''} */}
    </Fragment>
  );
};

export default Evaluate;
